// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"264":"d2b9ae4e","404":"6c8d867e","774":"31c00848","919":"64f1fed1"}[chunkId] + ".chunk.js";
};